import React from "react";
import Helmet from "react-helmet";
import _ from "lodash";

import Divider from "../components/Divider";
import ParallaxDivider from "../components/ParallaxDivider";
import HalfScreenParallaxHero from "../components/HalfScreenParallaxHero";
import HeadingDescription from "../components/HeadingDescription";
import ThreeFeaturesRow from "../components/ThreeFeaturesRow";
import TrailingIcon from "../components/TrailingIcon";
import SplitImageTop, { splitImg } from "../components/SplitImageTop";
import SplitImageBottom from "../components/SplitImageBottom";
import KeyPerson from "../components/KeyPerson";
import MainService from "../components/MainService";
import HeadingAndDescription from "../components/HeadingAndDescription";
import PrimaryHeading from "../components/PrimaryHeading";
import BoosterService from "../components/BoosterService";

class servicesPage extends React.Component {
  render() {
    const dataql = this.props.data;
    const acf = this.props.data.wordpressPage.acf;

    return (
      <div className="wow fadeIn">
        <Helmet title="Services | Moon Beyond Co" />
        <HalfScreenParallaxHero
          title="Services"
          bg={acf.background_image.localFile.childImageSharp.resolutions.src}
          symbol={acf.symbol.localFile.childImageSharp.sizes.src}
        />
        {/* Learn More */}
        <div className="container">
          <HeadingAndDescription
            heading={acf.first_heading}
            description={acf.first_heading_description}
            theme="black"
            element="orange"
          />
          <ThreeFeaturesRow
            features={acf.three_skills}
            skillOrStrength="skill"
          />
        </div>
        <Divider color="grey" />
        {/* End Learn More */}
        {/* Split Background */}
        <SplitImageTop
          img={dataql.splitImgTop}
          heading={acf.split_background_heading}
          subheading={acf.split_background_subheading}
          numberLabel={dataql.numberLabel1.sizes.src}
        />
        {/* end split background*/}
        {/* Main Services*/}
        <div className="container-fluid" style={{ marginBottom: 64 }}>
          {acf.services.map((a, i) => {
            return (
              <MainService
                key={i}
                index={i}
                img={a.image}
                description={a.description}
                tags={a.tag_filter}
                name={a.name}
              />
            );
          })}
        </div>
        {/* END Main Services*/}
        {/* Main Services Description Section */}
        <div className="container">
          <HeadingAndDescription
            heading={acf.main_services_description_section_heading}
            description={acf.main_services_description_section_text}
            theme="black"
            element="orange"
          >
            <TrailingIcon img={dataql.trailingIcon} />
          </HeadingAndDescription>
        </div>
        {/* Parallax */}
        <ParallaxDivider
          tagline={acf.parallax_section_text}
          taglineColor="#fff"
          bg={acf.parallax_section_image.localFile.childImageSharp.sizes.src}
          trailingElementColor="orange"
        />
        <Divider color="black" />
        {/* All Services */}
        <div className="allServices">
          <div className="container">
            <div className="row headingSection">
              <div className="col-xs-12 text-center">
                <PrimaryHeading
                  heading={acf.all_services_heading}
                  subheading={acf.all_services_subheading}
                  img={dataql.numberLabel2.sizes.src}
                  color="black"
                />
              </div>
            </div>
            <div className="allServices__items">
              {_.chunk(acf.all_services, 3).map((a, i) => (
                <div className="row" key={i}>
                  {a.map((b, i) => (
                    <BoosterService
                      key={i}
                      name={b.skill_name}
                      tags={b.skill_description}
                      img={b.skill_image.localFile.childImageSharp.sizes.src}
                    />
                  ))}
                </div>
              ))}
            </div>
            <HeadingAndDescription
              heading={acf.all_services_description_heading}
              description={acf.all_services_description_paragraph}
              theme="black"
              element="white"
            >
              <TrailingIcon img={dataql.trailingIcon2} bigTopPadding />
            </HeadingAndDescription>
          </div>
        </div>
        {/* end all service*/}
        <SplitImageBottom
          img={dataql.splitImgBottom}
          blurb={acf.next_page_blurb}
          link="../portfolio"
          linkText={acf.next_page_button_text}
        />
      </div>
    );
  }
}

export default servicesPage;

export const query = graphql`
  query servicesPageQuery {
    wordpressPage(title: { eq: "Services" }) {
      id
      title
      content
      excerpt
      date
      modified
      slug
      acf {
        background_image {
          localFile {
            childImageSharp {
              ...HeaderBG
            }
          }
        }
        symbol {
          localFile {
            childImageSharp {
              sizes(maxWidth: 1920) {
                src
              }
            }
          }
        }
        split_image_top {
          localFile {
            childImageSharp {
              sizes(maxWidth: 1920) {
                ...GatsbyImageSharpSizes
              }
            }
          }
        }
        split_image_bottom {
          localFile {
            childImageSharp {
              sizes(maxWidth: 1920) {
                ...GatsbyImageSharpSizes
              }
            }
          }
        }
        next_page_blurb
        next_page_button_text
        next_page_link
        title
        first_heading
        first_heading_description
        subtitle
        split_background_heading
        split_background_subheading
        services {
          name
          description
          tag_filter
          image {
            localFile {
              childImageSharp {
                sizes(maxWidth: 960, quality: 75) {
                  src
                }
              }
            }
          }
        }
        main_services_description_section_heading
        main_services_description_section_text
        parallax_section_text
        parallax_section_image {
          localFile {
            childImageSharp {
              sizes(maxWidth: 1920) {
                src
              }
            }
          }
        }
        three_skills {
          skill_name
          skill_desc
          skill_image {
            localFile {
              childImageSharp {
                resolutions(width: 200) {
                  ...GatsbyImageSharpResolutions
                }
              }
            }
          }
        }
        three_skills {
          skill_name
          skill_desc
        }
        all_services_heading
        all_services_subheading
        all_services_description_heading
        all_services_description_paragraph
        all_services {
          skill_name
          skill_image {
            localFile {
            childImageSharp {
              sizes(maxWidth: 1920) {
                src
              }
            }
          }
          }
          skill_description
        }
      }
    }

    trailingIcon: imageSharp(id: { regex: "/trailing_icon_services.png/" }) {
      resolutions(width: 350) {
        src
      }
    }
    trailingIcon2: imageSharp(id: { regex: "/trailing_icon_services2.png/" }) {
      resolutions(width: 350, quality: 100) {
        src
      }
    }

    splitImgTop: imageSharp(id: { regex: "/mb/services_split_top.png/" }) {
      ...SplitImg
    }
    splitImgBottom: imageSharp(
      id: { regex: "/mb/services_split_bottom.png/" }
    ) {
      ...SplitImg
    }

    headerBG: imageSharp(id: { regex: "/mb/services_header.jpg/" }) {
      ...HeaderBG
    }

    numberLabel1: imageSharp(id: { regex: "/mb/services/label-numbers-services01.png/" }) {
      sizes(maxWidth: 211) {
        src
      }
    }

    numberLabel2: imageSharp(id: { regex: "/mb/services/label-numbers-services02.png/" }) {
      sizes(maxWidth: 211) {
        src
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/services.js